// 案件认定
import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'
//分页
export function getDetermineList(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/caseWritPage`,
        method: 'post',
        data
    })
}
//认定意见
export function getDetermineOpinion(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseConclusiveOpinion/gl/v1.0.0/conclusiveOpinion`,
        method: 'post',
        data
    })
}
//导出案件认定
export function exportCase(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/caseWritExport`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
// 修改认定意见
export function updateDetermineOpinion(data) {
return request({
    url: `/${systemConfig.businessPrefix}/identificationCaseConclusiveOpinion/gl/v1.0.0/updateConclusiveOpinion`,
    method: 'post',
    data
    })
}
// 案件认定详情
export function getDetermineDetail(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseConclusiveOpinion/gl/v1.0.0/detailByCaseId`,
        method: 'post',
        data
    })
}